<template>
    <h2 class="product-reviews-title">
        <slot />
    </h2>
</template>

<script>
    export default {
        name: "ProductReviewsTitle",
        selector: "product-reviews-title",
    }
</script>

<style lang="scss" scoped>
    .product-reviews-title {
        font-weight: 600;
        font-size: rem(14);
        line-height: 120%;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        text-align: center;
        color: #7b7c7e;
        margin-bottom: 15px;
        @include point-md{
            font-size: rem(20);
            line-height: 125%;
        }
    }
</style>